import { render, staticRenderFns } from "./AttendanceCorrectionsDetail.vue?vue&type=template&id=2059f866&scoped=true"
import script from "./AttendanceCorrectionsDetail.vue?vue&type=script&lang=js"
export * from "./AttendanceCorrectionsDetail.vue?vue&type=script&lang=js"
import style0 from "./AttendanceCorrectionsDetail.vue?vue&type=style&index=0&id=2059f866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2059f866",
  null
  
)

export default component.exports